export default __webpack_public_path__ + "static/media/vae7.9b7e52c9.png";